export type BlogPost = {
  slug: string
  title: string
  excerpt: string
  date: string
  /** Last substantive revision. Falls back to `date` when a post has not
   *  been revised since publication. */
  dateModified?: string
  category: string
  readTime: string
  author: string
}

export const posts: BlogPost[] = [
  {
    slug: 'annual-100-hour-progressive-phase-inspections',
    title: 'Annual vs 100-Hour vs Progressive vs Phase Inspections: Which Applies to Your Aircraft',
    excerpt:
      'Four inspection programs appear in FAR 91.409, and the aircraft category and how it is operated decide which one applies. How each works, who can sign it off, and which your aircraft needs.',
    date: '2026-10-22',
    category: 'Maintenance',
    readTime: '10 min read',
    author: 'Michigan Aviation Team',
  },
  {
    slug: 'aircraft-paint-cost-downtime-michigan',
    title: 'Aircraft Paint Cost and Downtime in Michigan',
    excerpt:
      'Published paint prices and downtime by aircraft class, what custom options add, why prep fills most of the schedule, and how Michigan winters change the planning.',
    date: '2026-10-17',
    category: 'Paint',
    readTime: '9 min read',
    author: 'Michigan Aviation Team',
  },
  {
    slug: 'aircraft-strip-and-repaint-process',
    title: 'The Aircraft Strip and Repaint Process, Step by Step',
    excerpt:
      'The 14 steps of a full strip and repaint, what a complete inspection checks for hidden corrosion, and how temperature and humidity affect curing, with published phase timings and a handover checklist.',
    date: '2026-10-17',
    category: 'Paint',
    readTime: '11 min read',
    author: 'Michigan Aviation Team',
  },
  {
    slug: 'jet-a-vs-100ll-engine-compatibility',
    title: 'Jet-A vs 100LL: Engine Compatibility, Misfueling Risks and Fuel Quality Checks',
    excerpt:
      'Engine certification decides the grade, not the airframe. Which engines burn Jet-A and which need avgas, what the wrong fuel actually does, how misfueling is prevented, and what to ask any FBO about fuel quality.',
    date: '2026-10-17',
    category: 'Fueling',
    readTime: '9 min read',
    author: 'Michigan Aviation Team',
  },
  {
    slug: 'verify-used-aircraft-parts-airworthiness',
    title: 'How to Verify a Used Aircraft Part Is Airworthy',
    excerpt:
      'A used part is only worth buying if its paperwork, markings and condition all agree. Here is the order to check them in, what each document actually proves, and the conditions that make a part scrap regardless of price.',
    date: '2026-10-17',
    category: 'Maintenance',
    readTime: '10 min read',
    author: 'Michigan Aviation Team',
  },
  {
    slug: 'aircraft-fuel-contamination-guide',
    title: 'Aircraft Fuel Contamination: Causes, Sump Checks and Prevention',
    excerpt: 'Water, microbial growth and particulates are the three contaminants most likely to reach your tanks. Here is how each one gets in, what a sump check actually tells you, and how to keep fuel clean through a Michigan winter.',
    date: '2026-10-17',
    category: 'Fueling',
    readTime: '11 min read',
    author: 'Michigan Aviation Team',
  },
  {
    slug: 'williams-international-ain-2026-product-support-survey',
    title: "Williams International Ranks #2 in AIN's 2026 Engine Support Survey and Tops the Authorized Service Center Category",
    excerpt: 'Williams scored 9.40 for authorized service centers, the highest rating any turbofan OEM earned in any category. Here is what that means for Citation owners in Michigan.',
    date: '2026-10-09',
    category: 'Maintenance',
    readTime: '8 min read',
    author: 'Michigan Aviation Team',
  },
  {
    slug: 'lycoming-vs-continental-engine-preheat',
    title: 'Lycoming vs Continental: When Does Your Engine Need Preheat?',
    excerpt: 'Lycoming and Continental set different temperature thresholds for engine preheat. Here is what piston owners should know before a cold-weather start in Michigan.',
    date: '2026-10-06',
    category: 'Maintenance',
    readTime: '6 min read',
    author: 'Michigan Aviation Team',
  },
  {
    slug: 'type-i-vs-type-iv-deicing-fluid',
    title: 'Type I vs Type IV Deicing Fluid: What\u2019s the Difference?',
    excerpt: 'Type I removes ice. Type IV keeps it from coming back. Here is what pilots should know about deicing vs anti-icing, holdover time, hangar deicing, and which fluids actually fit which aircraft.',
    date: '2026-10-06',
    category: 'FBO',
    readTime: '7 min read',
    author: 'Michigan Aviation Team',
  },
  {
    slug: 'business-jet-wifi-security-starlink',
    dateModified: '2026-10-15',
    title: 'How to Secure Starlink and Cabin Wi-Fi on a Business Jet',
    excerpt: 'A seven-step checklist for securing business-jet Starlink and cabin Wi-Fi: passwords, network ownership, segmentation, VPN use, updates and access policies.',
    date: '2026-08-27',
    category: 'Avionics',
    readTime: '8 min read',
    author: 'Michigan Aviation Team',
  },
  {
    slug: 'connected-cockpit-garmin-trend',
    title: 'The Connected Cockpit: What Garmin AXIS and Mobile Clearance Delivery Signal for General Aviation',
    excerpt: 'Garmin AXIS in the panel and Mobile Clearance Delivery on the tablet point to the same trend: a more connected, digital general aviation workflow. What it means for pilots, owners, FBOs, and flight departments.',
    date: '2026-08-19',
    category: 'Avionics',
    readTime: '6 min read',
    author: 'Michigan Aviation Team',
  },
  {
    slug: 'garmin-pilot-mobile-clearance-delivery',
    title: 'Garmin Pilot Update: What Mobile Clearance Delivery Means for Pilots and FBO Operations',
    excerpt: 'Garmin Pilot\u2019s August 2026 update adds a redesigned Flights page and a new Mobile Clearance Delivery capability for eligible IFR flights. Here is what the digital clearance workflow means for pilots, FBOs, and flight departments.',
    date: '2026-08-11',
    dateModified: '2026-10-15',
    category: 'Avionics',
    readTime: '5 min read',
    author: 'Michigan Aviation Team',
  },
  {
    slug: 'garmin-axis-vs-g3x-vs-g500-txi',
    dateModified: '2026-10-15',
    title: 'Garmin AXIS vs G3X Touch vs G500 TXi: Which Garmin Panel Upgrade Fits Your Aircraft?',
    excerpt: 'Garmin\u2019s new AXIS Flight Display System changes the panel upgrade conversation. Here is how AXIS compares against both G3X Touch and G500 TXi, and which owners should be weighing all three.',
    date: '2026-07-08',
    category: 'Avionics',
    readTime: '6 min read',
    author: 'Michigan Aviation Team',
  },
  {
    slug: 'garmin-axis-compatible-aircraft',
    title: 'Which Aircraft Are Compatible with the Garmin AXIS Flight Display System?',
    excerpt: 'Garmin\u2019s new AXIS Flight Display System is creating buzz among owners planning a panel upgrade. Here is which aircraft Garmin is targeting at launch, why AXIS is getting attention, and how to evaluate whether it may fit your airplane.',
    date: '2026-07-08',
    category: 'Avionics',
    readTime: '6 min read',
    author: 'Michigan Aviation Team',
  },
  {
    slug: 'most-commonly-replaced-cessna-citation-parts',
    title: 'Most Commonly Replaced Cessna Citation Parts',
    excerpt: 'A Citation lives and dies by departure reliability, and that single expectation explains which parts matter most. A look at the components Citation operators replace most often, grouped by what gets used daily, what the calendar forces, and what has to be current before the jet can legally depart.',
    date: '2026-06-27',
    category: 'Maintenance',
    readTime: '9 min read',
    author: 'Michigan Aviation Team',
  },
  {
    slug: 'most-commonly-replaced-turboprop-aircraft-parts',
    title: 'Most Commonly Replaced Turboprop Aircraft Parts',
    excerpt: 'A turboprop asks far more of its systems than a piston twin ever will, and the parts list reflects it. Walking the airplane system by system, from the engine and start cycle to the gear, the ice and cabin systems, and the propeller, shows owners exactly where turbine wear tends to land.',
    date: '2026-06-27',
    category: 'Maintenance',
    readTime: '8 min read',
    author: 'Michigan Aviation Team',
  },
  {
    slug: 'most-commonly-replaced-aircraft-parts',
    title: 'Most Commonly Replaced Aircraft Parts for Piston, Turboprop, and Citation Aircraft',
    excerpt: 'Different aircraft categories create repeat demand around certain wear items, inspection-driven parts, and system-critical components. Here is a practical look at the parts owners and operators replace most across piston, turboprop, and Citation aircraft.',
    date: '2026-06-27',
    category: 'Maintenance',
    readTime: '9 min read',
    author: 'Michigan Aviation Team',
  },
  {
    slug: 'garmin-gad43e-software-update-g500-txi-g600-g700',
    title: 'Garmin GAD 43e Software Update for G500 TXi, G600, and G700: What Owners Should Check',
    excerpt: 'Garmin\u2019s latest GAD 43e update addresses autopilot disconnect logic and an ARINC 429 timing issue in certain G500 TXi, G600, and G700 installations. Here is what aircraft owners and operators should know before scheduling avionics work.',
    date: '2026-06-12',
    category: 'Avionics',
    readTime: '6 min read',
    author: 'Michigan Aviation Team',
  },
  {
    slug: 'southeast-michigan-weather-aircraft-storage',
    dateModified: '2026-10-15',
    title: 'How Southeast Michigan Weather Affects Aircraft Storage and Why Heated Hangars Matter at KPTK',
    excerpt: 'Southeast Michigan weather cycles between summer heat, corrosive winter road salt, freeze-thaw damage, and high humidity. Heated hangar storage at KPTK protects aircraft from all four.',
    date: '2026-05-17',
    category: 'Hangar',
    readTime: '8 min read',
    author: 'Michigan Aviation Team',
  },
  {
    slug: 'hangar-rental-near-pontiac-kptk',
    dateModified: '2026-10-15',
    title: 'How to Evaluate a Hangar Lease Near Pontiac and KPTK',
    excerpt: 'Compare a hangar lease near Pontiac and KPTK: aircraft fit, total cost, access, heating and on-site service before choosing a space.',
    date: '2026-05-15',
    category: 'Hangar',
    readTime: '7 min read',
    author: 'Michigan Aviation Team',
  },
  {
    slug: 'choose-best-fbo-kptk-southeast-michigan',
    dateModified: '2026-10-15',
    title: 'How to Choose an FBO at KPTK or in Southeast Michigan: A Practical Checklist',
    excerpt: 'Use this general FBO checklist to compare fuel value, maintenance access, ground support, crew needs and overnight arrangements at KPTK and across Southeast Michigan.',
    date: '2026-05-13',
    category: 'Operations',
    readTime: '10 min read',
    author: 'Michigan Aviation Team',
  },
  {
    slug: 'aircraft-wifi-cybersecurity',
    dateModified: '2026-10-15',
    title: 'Cybersecurity for Business Aviation Passengers: Data Protection and Deepfake Risks',
    excerpt: 'How business aviation passengers and crews can protect sensitive data, recognize executive impersonation and reduce cyber risks on aircraft and FBO networks.',
    date: '2026-05-08',
    category: 'Operations',
    readTime: '10 min read',
    author: 'Michigan Aviation Team',
  },
  {
    slug: 'flying-into-kptk-guide',
    dateModified: '2026-10-15',
    title: 'Everything You Need to Know About Flying Into KPTK: Fuel, Hangars, and FBO Services',
    excerpt: 'KPTK offers three runways including a 6,521-foot ILS-equipped primary, and Class D airspace with no commercial traffic. Here is why operators choose it over DTW.',
    date: '2026-05-09',
    category: 'Operations',
    readTime: '10 min read',
    author: 'Michigan Aviation Team',
  },
  {
    slug: 'aviation-parts-shortage-annual',
    title: 'What the 2026 Aviation Parts Shortage Means for Your Next Aircraft Annual in Michigan',
    excerpt: 'Global supply chain disruptions are driving parts delays across general aviation. Components that arrived in days now take weeks. Here is how to plan around it.',
    date: '2026-05-09',
    category: 'Maintenance',
    readTime: '10 min read',
    author: 'Michigan Aviation Team',
  },
  {
    slug: 'avionics-upgrade-ifr-season',
    title: '5 Signs Your Aircraft\'s Avionics Need an Upgrade Before the 2026 IFR Season',
    excerpt: 'Summer VMC conditions hide avionics problems that become real risks once fall IFR season arrives. Here are the five warning signs to watch for.',
    date: '2026-05-06',
    category: 'Avionics',
    readTime: '10 min read',
    author: 'Michigan Aviation Team',
  },
  {
    slug: 'michigan-aviation-vs-kptk-fbos',
    title: 'Michigan Aviation vs. Other KPTK FBOs: Why Owners and Flight Departments Choose Us',
    excerpt: 'Michigan Aviation is KPTK\'s maintenance-centric FBO: full-service FBO + in-house FAA Part 145 repair station, decades on the field, competitive fuel pricing, and a safety-first culture.',
    date: '2026-04-08',
    category: 'Operations',
    readTime: '10 min read',
    author: 'Michigan Aviation Team',
  },
  {
    slug: 'fueling-smart-volatile-market',
    title: 'Fueling Smart in a Volatile 2026 Market: What Michigan Private Aviation Needs to Know Right Now',
    excerpt: 'Jet-A prices have surged nearly 60% since early 2026 — here\'s what private jet operators, charter companies, and corporate flight departments can do about it.',
    date: '2026-04-05',
    category: 'Fueling',
    readTime: '10 min read',
    author: 'Michigan Aviation Team',
  },
  {
    slug: 'safety-at-kptk',
    title: 'How Michigan Aviation Thinks About Safety at KPTK',
    excerpt: 'Ask ten aviation companies about safety and you\'ll hear the same words. At Michigan Aviation, those ideas only mean something if they show up in the work.',
    date: '2026-03-15',
    category: 'Operations',
    readTime: '8 min read',
    author: 'Michigan Aviation Team',
  },
  {
    slug: 'reducing-aircraft-downtime',
    title: 'Keeping Aircraft Downtime in Check at KPTK',
    excerpt: 'Nobody plans a trip around sitting on the ground. Yet small delays can stack up until an aircraft spends more time parked than flying.',
    date: '2026-03-01',
    category: 'Maintenance',
    readTime: '7 min read',
    author: 'Michigan Aviation Team',
  },
  {
    slug: 'onsite-avionics-maintenance',
    title: 'Why On-Site Avionics and Maintenance Support Matter at KPTK',
    excerpt: 'When avionics and maintenance teams work side by side, they can look at an aircraft as a system, not a collection of disconnected components.',
    date: '2026-02-20',
    category: 'Avionics',
    readTime: '6 min read',
    author: 'Michigan Aviation Team',
  },
  {
    slug: 'airport-office-space',
    title: 'When Office Space at the Airport Actually Makes Sense',
    excerpt: 'Deciding whether to lease office space at the airport depends on what kind of operation you\'re running.',
    date: '2026-01-25',
    category: 'Office Space',
    readTime: '5 min read',
    author: 'Michigan Aviation Team',
  },
  {
    slug: 'fuel-price-alerts',
    title: 'How Weekly Fuel Price Alerts Help Operators Plan Smarter at KPTK',
    excerpt: 'Michigan Aviation\'s weekly fuel price alerts remove some of the guesswork for operators who rely on KPTK.',
    date: '2026-01-10',
    category: 'Fueling',
    readTime: '4 min read',
    author: 'Michigan Aviation Team',
  },
]

/** Every post on the site, newest first. Single source of truth for the
 *  blog index, the sitemap, and related-article links. */
export const allBlogPosts: BlogPost[] = [...posts].sort((a, b) =>
  b.date.localeCompare(a.date),
)

export const featuredPost = getPostBySlug('choose-best-fbo-kptk-southeast-michigan')

/** Looks up a post by slug. Throws at build time if a page references a slug
 *  that is missing from this list, which keeps pages and the sitemap in sync. */
export function getPostBySlug(slug: string): BlogPost {
  const post = allBlogPosts.find((p) => p.slug === slug)
  if (!post) {
    throw new Error(`Unknown blog slug: ${slug}`)
  }
  return post
}

/** The date a post was last substantively revised. */
export function getPostModifiedDate(post: BlogPost): string {
  return post.dateModified ?? post.date
}
